import { ChangeDetectionStrategy, Component, computed, effect, forwardRef, input, output } from "@angular/core";
import { FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";

import { BaseControlValueAccessorComponent } from "../base/base-control-value-accessor.component";

@Component({
  selector: "component-toggle",
  templateUrl: "./toggle.component.html",
  styleUrl: "./toggle.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleComponent),
      multi: true
    }
  ]
})
export class ToggleComponent extends BaseControlValueAccessorComponent<boolean> {
  readonly checked = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly label = input<string>("");
  readonly checkedChange = output<boolean>();

  private static _nextId = 0;
  protected readonly inputId = computed(() => `toggle-${ToggleComponent._nextId++}`);
  private _hasFormControlValue = false;

  constructor() {
    super();
    // Set initial value from checked input only if no form control value has been set
    effect(() => {
      if (!this._hasFormControlValue && this._value() === null) {
        this._value.set(this.checked());
      }
    });
  }

  override writeValue(value: boolean | null): void {
    // Mark that a form control value has been written
    this._hasFormControlValue = true;
    super.writeValue(value);
  }

  protected onToggle(checked: boolean): void {
    this._value.set(checked);
    this.onChange(checked); 
    this.checkedChange.emit(checked);
  }
}
